import { useState, useEffect } from 'react';

interface NavItem {
  label: string;
  href: string;
}

const navItems: NavItem[] = [
  { label: '首页', href: '#hero' },
  { label: '最新上架', href: '#updates' },
  { label: '影片导览', href: '#index' },
  { label: '热播排行', href: '#ranking' },
  { label: '平台特色', href: '#features' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMobileOpen(false);
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-100/95 backdrop-blur-md border-b border-background-300/40'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-16">
          <a
            href="#hero"
            onClick={(e) => handleNavClick(e, '#hero')}
            className="flex items-center gap-2 group"
          >
            <span className="text-2xl font-bold font-heading text-primary-500">
              6080
            </span>
            <span className="text-sm font-medium text-foreground-800 hidden sm:inline">
              影院
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className="px-4 py-2 text-sm font-medium text-foreground-600 hover:text-primary-400 rounded-lg transition-colors duration-200 whitespace-nowrap"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="#hero"
              onClick={(e) => handleNavClick(e, '#hero')}
              className="px-5 py-2 text-sm font-medium bg-primary-500 hover:bg-primary-600 text-background-50 dark:text-foreground-950 rounded-md transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              开始观影
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
            aria-label="打开菜单"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-100/98 backdrop-blur-md border-b border-background-300/40">
          <div className="px-4 py-4 flex flex-col gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className="px-4 py-3 text-sm font-medium text-foreground-600 hover:text-primary-400 hover:bg-background-200/60 rounded-lg transition-colors duration-200 whitespace-nowrap"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#hero"
              onClick={(e) => handleNavClick(e, '#hero')}
              className="mt-2 px-4 py-3 text-sm font-medium bg-primary-500 hover:bg-primary-600 text-background-50 dark:text-foreground-950 rounded-md text-center transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              开始观影
            </a>
          </div>
        </div>
      )}
    </header>
  );
}